(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('AdminConfigurationController', AdminConfigurationController);

    AdminConfigurationController.$inject = [
        'AdminConfigurationService', 'CLIENTTYPECONSTANT', 'COUNTRYCODECONSTANT', 'ClientService',
        'PlagiatValidationService', '$mdDialog', 'AccountService',
        'ModalService', '$translate', 'DetectInstanceService'];

    function AdminConfigurationController (
        AdminConfigurationService, CLIENTTYPECONSTANT, COUNTRYCODECONSTANT, ClientService,
        PlagiatValidationService, $mdDialog, AccountService,
        ModalService, $translate, DetectInstanceService) {

        var vm = this;
        vm.activeTab = 'adminConfiguration';
        vm.clientTypeConstant = CLIENTTYPECONSTANT;

        this.$onInit = function () {
            vm.instance = DetectInstanceService.instance();
            onInit();
        };
        vm.model = {};
        vm.save = save;

        vm.configuration = {
            reportSettings: [
                {label: 'ignoring-bibliography', model: 'ignoringBibliography'},
                {label: 'ignoring-citations', model: 'ignoringCitations'},
                {label: 'warning-thresholds', model: 'warningThresholds'},
                {label: 'report-2020-operator-can-edit', model: 'report2020OperatorCanEdit'},
                {label: 'excluding-citations', model: 'excludingCitations'},
                {label: 'hide-docu-similarity-factor-ext', model: 'hideDocuSimilarityFactorExt'},
                {label: 'show-self-citation-factor', model: 'showSelfCitationFactor'},
                {label: 'show-reversed-similarity-factor', model: 'showReversedSimilarityFactor'},
                {label: 'report-2020-no-submit-button', model: 'report2020NoSubmitButton'},
                {label: 'hide-metadata', model: 'hideMetadata'},
                {label: 'qr-code', model: 'qrCode'},
            ],
            aiDetectionSettings: [
                {label: 'ai-detection-exclude-fragments', model: 'aiDetectionExcludeFragments'},
            ],
            addToDatabase: [
                {value: 'without'},
                {value: 'manually'},
                {value: 'automatically'},
                {value: 'delayed'}
            ],
            otherSettings: [
                {label: 'perm-user-document-verification', model: 'permUserDocumentVerification'},
                {label: 'perm-user-check-document-metric-similarity-before-add', model: 'permUserCheckDocumentMetricSimilarityBeforeAdd'},
                {label: 'send-alert-to-promoter', model: 'sendAlertToPromoter'},
                {label: 'send-alert-to-student', model: 'sendAlertToStudent'},
                {label: 'perm-user-do-not-use-copy-paste', model: 'permUserDoNotUseCopyPaste'},
                {label: 'perm-user-upload-support', model: 'permUserUploadSupport'},
                {label: 'no-document-upload-for-students', model: 'noDocumentUploadForStudents'},
                {label: 'restricting-databases', model: 'restrictingDatabases'},
                {label: 'accept-regulations-enabled', model: 'acceptRegulationsEnabled'},//+ edition of the regulations url
                {label: 'auto-translations-lang-selection', model: 'autoTranslationsLangSelection'},
                {label: 'disable-skip-sites-url', model: 'disableSkipSitesUrl'}
            ],
            jsaOrppdSettings: [
                {label: 'jsa-run-ai-detection', model: 'jsaRunAiDetection'},
            ],
            userSettings: [
                {label: 'allow-edit-document', model: 'allowEditDocument'},
                {label: 'perm-user-cant-see-the-documents-of-others', model: 'permUserCantSeeTheDocumentsOfOthers'},
                {label: 'user-teacher-can-change-promoter', model: 'userTeacherCanChangePromoter'},
                {label: 'perm-user-can-change-organisational-unit', model: 'permUserCanChangeOrganisationalUnit'},
                {label: 'perm-users-can-download-original-file', model: 'permUsersCanDownloadOriginalFile'}
            ],
            uploadPermissions: [
                {label: 'txt-support', model: 'txtSupport'},
                {label: 'pdf-support', model: 'pdfSupport'},
                {label: 'doc-support', model: 'docSupport'},
                {label: 'docx-support', model: 'docxSupport'},
                {label: 'odt-support', model: 'odtSupport'},
                {label: 'rtf-support', model: 'rtfSupport'},
                {label: 'ppt-support', model: 'pptSupport'},
                {label: 'pptx-support', model: 'pptxSupport'},
                {label: 'html-support', model: 'htmlSupport'},
                {label: 'postscript-support', model: 'postscriptSupport'},
                {label: 'wordperfect-support', model: 'wordperfectSupport'}
            ],
            addToDatabaseSettings: [
                {label: 'teacher-cant-delete-from-database', model: 'teacherCantDeleteFromDatabase'},
                {label: 'hide-add-without-checking', model: 'hideAddWithoutChecking'},
                {label: 'only-admin-can-add', model: 'onlyAdminCanAddToDatabase'},
            ],
            rareSettings: [
                {label: 'all-users-can-delete-documents', model: 'allUsersCanDeleteDocuments'},
                {label: 'all-users-can-delete-accounts', model: 'allUsersCanDeleteAccounts'},
                {label: 'hide-user-history', model: 'hideUserHistory'},
                {label: 'no-document-upload-for-students', model: 'noDocumentUploadForStudents'},
                {label: 'document-kind-due-date', model: 'documentKindDueDate'},
                {label: 'coordinator-not-required-by-default', model: 'coordinatorNotRequiredByDefault'}
            ]
        };

        vm.available = function(model) {
            switch (model) {
                case 'userSettingsCard':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse();

                    // otherSettings
                case 'permUserDocumentVerification':
                    return isAnyUniversity();
                case 'acceptRegulationsEnabled':
                    return isAnyUniversity();
                case 'permUserCheckDocumentMetricSimilarityBeforeAdd':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse() || AccountService.clientType.isSchool();
                case 'noDocumentUploadForStudents':
                    return AccountService.clientType.isSchool();
                case 'sendAlertToPromoter':
                    return isAnyUniversity() || AccountService.clientType.isSchool();
                case 'sendAlertToStudent':
                    return AccountService.clientType.isSchool();
                case 'permUserDoNotUseCopyPaste':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse() || AccountService.clientType.isSchool();
                case 'permUserUploadSupport':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse() || AccountService.clientType.isSchool();
                case 'autoTranslationsLangSelection':
                    return isAnyUniversity() || AccountService.clientType.isSchool();
                case 'disableSkipSitesUrl':
                    return true;
                    // user settings
                case 'allowEditDocument':
                    return true;
                case 'permUserCantSeeTheDocumentsOfOthers':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse();
                case 'userTeacherCanChangePromoter':
                    return isAnyUniversity();
                case 'permUserCanChangeOrganisationalUnit':
                    return isAnyUniversity() || AccountService.clientType.isSchool();
                case 'permUsersCanDownloadOriginalFile':
                    return isAnyUniversity() || AccountService.clientType.isSchool();
                    // jsaOrppdSettings
                case 'jsaOrppdCard':
                    return AccountService.account.clientSettings.jsaIntegration
                        || (AccountService.clientType.isClientTypeUnivAsap() && AccountService.clientCountryId === COUNTRYCODECONSTANT.POLAND_COLUMBIA.id);
                default:
                    return false;
            }
        };

        vm.availableInstance = function(model) {
            switch (model) {
                case 'showSelfCitationFactor':
                    return (vm.instance === 'int');
                default:
                    return true;
            }
        };

        function isAnyUniversity() {
            return AccountService.clientType.isClientTypeUnivStandard() || AccountService.clientType.isCodeAccount() || AccountService.clientType.isClientTypeUnivAsap() ;
        }

        function onInit() {
            vm.isLoading = true;
            AdminConfigurationService.getAdminConfiguration().then(function (success) {
                vm.model = success.data;
                vm.isLoading = false;
            }, function (response) {
                ModalService.showErrorModal(response);
                vm.isLoading = false;
            });
        }
        function save() {
            vm.isSaving = true;

            AdminConfigurationService.save(vm.model.configuration).then(
                function () {
                    vm.isSaving = false;
                    ModalService.showSuccessModal();
                },
                function (response) {
                    vm.isSaving = false;
                    ModalService.showErrorModal(response);
                    $mdToast.show($mdToast.simple().textContent($translate.instant("global.messages.error.label")));
                }
            );
        }

    }
})();
